"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandFailedError = void 0;
const custom_error_1 = require("./custom-error");
class CommandFailedError extends custom_error_1.CustomError {
    constructor(customMessage, command) {
        super(customMessage, custom_error_1.ERROR_CODES.CommandFailed);
        this.command = command;
    }
}
exports.CommandFailedError = CommandFailedError;
//# sourceMappingURL=command-failed-to-run-error.js.map